var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uni-startPractice" },
    [
      _c(
        "div",
        { staticClass: "leftBox" },
        [
          _c("Title", { attrs: { text: "我的笔记" } }, [
            _c("i", {
              staticClass: "iconfont iconfanhui icon-back",
              attrs: { slot: "right" },
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "myNotes" })
                },
              },
              slot: "right",
            }),
          ]),
          _c(
            "ul",
            _vm._l(_vm.datas, function (item, index) {
              return _c("li", { key: index, staticClass: "mat10" }, [
                _c(
                  "div",
                  [
                    _c(
                      "el-collapse",
                      {
                        model: {
                          value: _vm.activeNames,
                          callback: function ($$v) {
                            _vm.activeNames = $$v
                          },
                          expression: "activeNames",
                        },
                      },
                      [
                        _c(
                          "el-collapse-item",
                          {
                            staticClass: "question-collapse-item",
                            attrs: { name: item.question_id },
                          },
                          [
                            _c("template", { slot: "title" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "primary mar10",
                                  staticStyle: { "align-self": "flex-start" },
                                },
                                [
                                  _vm._v(
                                    "[" + _vm._s(item.question_title) + "]"
                                  ),
                                ]
                              ),
                              _c("span", { staticStyle: { flex: "1" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.textLength(item.question_title, item.id)
                                  )
                                ),
                              ]),
                            ]),
                            item.question_style === 4
                              ? _c("FillBlank", {
                                  attrs: {
                                    datas: item,
                                    isDisabled: _vm.isDisabled,
                                  },
                                })
                              : _vm._e(),
                            item.question_style === 1
                              ? _c("ChoiceOne", {
                                  attrs: {
                                    datas: item,
                                    isDisabled: _vm.isDisabled,
                                  },
                                })
                              : _vm._e(),
                            item.question_style === 3
                              ? _c("ChoiceMultiple", {
                                  attrs: {
                                    datas: item,
                                    isDisabled: _vm.isDisabled,
                                  },
                                })
                              : _vm._e(),
                            item.question_style === 2
                              ? _c("Judge", {
                                  attrs: {
                                    datas: item,
                                    isDisabled: _vm.isDisabled,
                                  },
                                })
                              : _vm._e(),
                            item.question_style === 5
                              ? _c("Subjective", {
                                  attrs: {
                                    datas: item,
                                    isDisabled: _vm.isDisabled,
                                  },
                                })
                              : _vm._e(),
                            _c("QuestionAnalysis", {
                              attrs: { showNotes: true, analysisDatas: item },
                              on: { delNote: _vm.delNote },
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            }),
            0
          ),
          _vm.datas.length == 0
            ? _c("ComponentEmpty", { attrs: { title: "暂无笔记", tips: "" } })
            : _vm._e(),
        ],
        1
      ),
      _c("ComponentDialog1", {
        attrs: {
          icon: "fail",
          title: "确定删除该笔记",
          visible: _vm.isDelconform,
          iconPosition: "left-top",
          showCancelBtn: true,
          cancelText: "取消",
          confirmText: "确定",
        },
        on: {
          "update:visible": function ($event) {
            _vm.isDelconform = $event
          },
          confirm: _vm.delConfirm,
          cancel: function ($event) {
            _vm.isDelconform = !_vm.isDelconform
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }